import React, {useEffect, useState} from "react";
import {
    Card,
    CardHeader,
    CardBody,
    Typography,
    Tooltip,
    Button, Input,

} from "@material-tailwind/react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import {ExclamationCircleIcon} from "@heroicons/react/16/solid";
import {getCurrentUserRole} from "../../utils/auth";

export default function LoginForm() {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loginError, setLoginError] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const handleLoginSubmit = async (e) => { e.preventDefault();

        const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/arcado_admin";

        try {
            const response = await axios.post(`${API_URL}/auth/login`, {
                username,
                password
            });
            const token = response.data.token;

            localStorage.setItem("token", token);
            const role = getCurrentUserRole();

            if (role === "USER" || !role) {
                localStorage.removeItem("token");
                setLoginError(true);
                return;
            }

            if (role === "WORKER") {
                navigate("/manga");
                return;
            }

            if (location.state && location.state.from) {
                navigate(location.state.from);
            } else {
                navigate("/home");
            }
        } catch (err) {
            setLoginError(true);
        }
    }

    useEffect(() => {
        setLoginError(false);
    }, [username, password]);

    const TooltipLoginError = () => {
        return (
            <div className="p-1">
                <p className=" text-red-500 font-bold">Invalid username or password</p>
            </div>
        );
    };

    function storeScrollPosition() {
        sessionStorage.setItem('scrollPosition', window.scrollY.toString());
    }

    return (
        <Card className="w-full max-w-3xl mx-auto rounded-3xl overflow-hidden shadow-2xl">
            <CardHeader
                color="gray"
                floated={false}
                style={{
                    backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5)), url("https://t3.ftcdn.net/jpg/03/07/98/68/360_F_307986813_STkK6emB0FbI5QDz6XhrgOEqvGNmoxW6.jpg")',
                    backgroundBlendMode: 'multiply'
                }}
                className="m-0 grid place-items-center rounded-b-none py-7 lg:py-10 px-4 bg-contain bg-center text-center"
            >
                <div className="mt-4 mb-4 rounded-full border border-white/10 text-white">
                    <img
                        src="/images/arcado-logo-solo-circle.png"
                        alt="Logo"
                        className="h-28 w-28"
                    />
                </div>
                <Typography variant="h4" color="white">
                    Arcado
                </Typography>
                <Typography variant="h6" color="white">
                    - Admin Dashboard -
                </Typography>
            </CardHeader>

            <CardBody>


                <div className="flow-root">
                    <div className="flow-root">
                        <div>
                            <Typography variant="h4" color="blue-gray">
                                Sign In
                            </Typography>
                            <form className="mt-6 mb-2" onSubmit={handleLoginSubmit}>
                                <div className="mb-4 flex flex-col gap-6">
                                    <Input color="cyan" size="lg" label="Username"
                                           value={username}
                                           onChange={(e) => setUsername(e.target.value)}
                                           error={loginError} />
                                    <Input color="cyan" type="password" size="lg" label="Password"
                                           value={password}
                                           onChange={(e) => setPassword(e.target.value)}
                                           error={loginError}
                                           icon={
                                               loginError && (
                                                   <Tooltip content={<TooltipLoginError/>} placement="top-end" size="sm" className="bg-gray-100 border-1 border-red-700">
                                                       <ExclamationCircleIcon className="text-red-500 h-5 w-5"/>
                                                   </Tooltip>
                                               )
                                           } />
                                </div>
                                <Button color="cyan" className="mt-8" fullWidth type="submit" onClick={storeScrollPosition}>
                                    Login
                                </Button>
                            </form>
                        </div>
                    </div>
                </div>

            </CardBody>
        </Card>
    );
}
